import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { componentOverrides } from 'themes/componentOverrides';
import { buildGlassSurfaces, buildPalette, radius } from 'themes/tokens';
import { brandLight } from './tokens/brand';
import typography from './typography';

/**
 * NewAiEye light theme.
 *
 * Every colour derives from the bases in tokens/brand.ts — brand, surfaces,
 * text, borders and the four product sub-palettes all come out of the
 * generated ramps.
 */
export const lightPalette = buildPalette(brandLight, 'light', {
  // Page background is the Home tint, per the token sheet.
  surfaceFrom: 'home'
});

const coreTheme = createTheme({
  palette: {
    ...lightPalette,
    glass: buildGlassSurfaces(lightPalette.primary.main)
  },
  radius,
  typography,
  components: componentOverrides
});

export default responsiveFontSizes(coreTheme);
